import React from 'react';
import styled from 'styled-components';
import { Option } from 'components/atoms/select';
import { Tag } from 'components/atoms/tag';
import { getRandomColor } from 'utils/get-random-color';

export const Container = styled.div`
  margin-top: var(--spacing-05);
`;

export const ValueRenderer = ({ userList }: { userList: Option[] }) => {
  return (
    <Container>
      {userList.map((user) => (
        <Tag color={getRandomColor(user.label)}>{user.label}</Tag>
      ))}
    </Container>
  );
};
